<a
  href="https://hubventory.com/b/pink-soul"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="The Boutique Hub - Pink Soul Store"
  style="text-decoration: none; display: block; margin: auto"
>
  <img
    src="https://theboutiquehub.com/wp-content/uploads/2021/01/Copy-of-TBH_mainlogo_pinkandblack-2048x610.png"
  />
</a>
